import { render } from "./lang-select.vue?vue&type=template&id=12411104&ts=true"
import script from "./lang-select.vue?vue&type=script&lang=ts"
export * from "./lang-select.vue?vue&type=script&lang=ts"

import exportComponent from "/mobefind/web/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__